import { gql } from '@apollo/client'

export const GET_ALL_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID = gql`
  query GetAllProcessesSubCategoriesByProcessCategoryId(
    $processCategoryId: Int!
    $filterSubCategories: Boolean
  ) {
    getAllProcessesSubCategoriesByProcessCategoryId(
      process_category_id: $processCategoryId
      filterSubCategories: $filterSubCategories
    ) {
      id
      name
      description
    }
  }
`

export const GET_PROCESSES_SUBCATEGORIES_BY_PROCESS_CATEGORY_ID = gql`
  mutation GetProcessesSubCategoriesByProcessCategoryId(
    $processCategoryId: Int!
  ) {
    getProcessesSubCategoriesByProcessCategoryId(
      process_category_id: $processCategoryId
    ) {
      id
      name
      description
    }
  }
`
